<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BVBTHg/tc-custom/9781426858161.jpg?1700801455894" alt="This image is the cover for the book Captive in His Bed"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Captive in His Bed
      </h1>
      <p class="bookDescription body article font2">
        <p>Matthew Knight is ex-security services and half-Comanche Native American. He's as rough, tough and dedicated in the field of risk management as they come. Mia Palmieri is an ordinary woman caught up in an extraordinary situation.<br/><br/>Matthew is on Mia's case to unearth the truth about her, and his only option is to kidnap her! But while she's held prisoner in his luxury hideaway, she can't resist his hard-muscled handsomeness. And though their lovemaking is hot and savage, Mia's still got a secret mission to fulfill….</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra Marton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b9ddbc8